import { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import logo from "../../assets/image/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { roleData } from "../../utils/constant";
import {
  FaHome,
  FaTicketAlt,
  FaUserFriends,
  FaCalendarAlt,
  FaTimes,
  FaUsers,
  FaClipboardCheck,
  FaWrench,
  FaTools,
  FaRegMoneyBillAlt,
  FaWallet,
  FaBoxes,
  FaCreditCard,
  FaRegLifeRing,
  FaClipboardList,
  FaFileInvoice,
} from "react-icons/fa";
import { useTypeConfig } from "../../utils/useTypeConfig";

function SidebarComponent({ toggled, setToggled }) {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("role");
  const { labels } = useTypeConfig();
  const userPermissions = localStorage.getItem("user_permissions");
  const [ticketSubMenuOpen, setTicketSubMenuOpen] = useState(false);
  const [fieldWorkerSubMenuOpen, setFieldWorkerSubMenuOpen] = useState(false);
  const [crmSubMenuOpen, setCrmSubMenuOpen] = useState(false);
  const [attendanceSubMenuOpen, setAttendanceSubMenuOpen] = useState(false);
  const [stockSubMenuOpen, setStockSubMenuOpen] = useState(false);

  const isAdmin = userRole === roleData.admin;
  const isSuperAdmin = userRole === roleData.superadmin;
  const isAgent = userRole === roleData.agent;
  const isSuperuser = userRole === roleData.superuser;
  const isCustomer = userRole === roleData.customer;
  const isTechnician = userRole === roleData.technician;
  const isSales = userRole === roleData.sales;
  const isSubCustomer = userRole === roleData.subcustomer;
  const punchInDate = localStorage.getItem("punch_in");
  const attendanceType = localStorage.getItem("attendence_type");
  const todayDate = new Date().toISOString().split("T")[0];
  const isPunchInMatched = punchInDate === todayDate;

  const shouldCheckPunchIn = !isAdmin && !isSubCustomer && !isCustomer;

  const showFullSidebar = shouldCheckPunchIn
    ? attendanceType === "machine" || isPunchInMatched
    : true;

  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const subscriptionStatus = localStorage.getItem("subscription_status");
  const isExpired = subscriptionStatus === "expired";

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 993);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
  });

  const handleMenuItemClick = (path) => {
    if (isExpired) {
      navigate("/dashboard/subscription");
      return;
    }

    navigate(path);

    if (isSmallScreen) {
      setToggled(false);
    }
  };

  return (
    <Sidebar
      toggled={toggled}
      onToggle={() => setToggled(!toggled)}
      breakPoint="lg"
      className="sidebarContainer"
      style={{
        height: "100vh",
        overflowY: "hidden",
        backgroundColor: "#ffffff",
        color: "black",
        marginBottom: "100px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {isSmallScreen && (
        <FaTimes
          className="toggleBar"
          style={{
            zIndex: 1000,
            color: "#333",
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
          }}
          onClick={() => setToggled(!toggled)}
          size={25}
        />
      )}

      <div className="text-center mb-3" style={{ marginTop: "20px" }}>
        <img
          src={logo}
          alt="logo"
          width={"100%"}
          height={100}
          style={{ objectFit: "cover" }}
        />
      </div>
      <div
        style={{
          pointerEvents: isExpired ? "none" : "auto",
          opacity: isExpired ? 0.5 : 1,
        }}
      >
        <Menu>
          <MenuItem
            onClick={() => handleMenuItemClick("/dashboard")}
            className={`mb-1 ${
              location.pathname === "/dashboard" ? "active-menu" : ""
            }`}
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            <FaHome className="me-2" />
            Dashboard
          </MenuItem>

          {isSuperAdmin && (
            <MenuItem
              onClick={() => handleMenuItemClick("/dashboard/invoices")}
              className={`submenu-item ${
                location.pathname === "/dashboard/invoices" ? "active-menu" : ""
              }`}
              style={{ fontWeight: "bold", fontSize: "16px" }}
            >
              <FaFileInvoice className="me-2" />
              Invoices
            </MenuItem>
          )}

          {isSuperAdmin && (
            <MenuItem
              onClick={() => handleMenuItemClick("/dashboard/support")}
              className={`mb-1 ${
                location.pathname === "/dashboard/support" ? "active-menu" : ""
              }`}
              style={{ fontWeight: "bold", fontSize: "16px" }}
            >
              <FaRegLifeRing className="me-2" /> Help & Support
            </MenuItem>
          )}
          {showFullSidebar ? (
            <>
              <div
                style={{
                  // pointerEvents: isDisabled ? "none" : "auto",
                  // opacity: isDisabled ? 0.5 : 1,
                  marginBottom: "100px",
                }}
              >
                {(userPermissions?.includes("ticket_view_ticket") ||
                  userPermissions?.includes("fsr_view_fsr")) && (
                  <SubMenu
                    className={`mb-1 submenu`}
                    open={ticketSubMenuOpen}
                    label={
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        <FaTicketAlt className="me-2" /> Ticket
                      </span>
                    }
                    onOpenChange={() =>
                      setTicketSubMenuOpen(!ticketSubMenuOpen)
                    }
                  >
                    {userPermissions?.includes("ticket_view_ticket") && (
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick("/dashboard/tickets")
                        }
                        className={`submenu-item ${
                          location.pathname === "/dashboard/tickets"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        Ticket
                      </MenuItem>
                    )}

                    {userPermissions?.includes("fsr_view_fsr") && (
                      <MenuItem
                        onClick={() => handleMenuItemClick("/dashboard/fsr")}
                        className={`submenu-item ${
                          location.pathname === "/dashboard/fsr"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        FSR
                      </MenuItem>
                    )}
                  </SubMenu>
                )}

                {isCustomer && (
                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("/dashboard/subcustomer")
                    }
                    className={`submenu-item ${
                      location.pathname === "/dashboard/subcustomer"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaUserFriends className="me-2" /> {labels.subCustomer}
                  </MenuItem>
                )}

                {!isCustomer && !isSubCustomer && (
                  <SubMenu
                    className={`mb-1 submenu`}
                    open={attendanceSubMenuOpen}
                    label={
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        <FaCalendarAlt className="me-2" /> Attendance
                      </span>
                    }
                    onOpenChange={() =>
                      setAttendanceSubMenuOpen(!attendanceSubMenuOpen)
                    }
                  >
                    <>
                      {userPermissions?.includes(
                        "attendance_view_attendance",
                      ) &&
                        !isAdmin && (
                          <MenuItem
                            onClick={() =>
                              handleMenuItemClick("/dashboard/my-attendence")
                            }
                            className={`submenu-item ${
                              location.pathname === "/dashboard/my-attendence"
                                ? "active-menu"
                                : ""
                            }`}
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            My Attendance
                          </MenuItem>
                        )}
                      {userPermissions?.includes(
                        "leavereport_view_leavereport",
                      ) &&
                        !isAdmin && (
                          <MenuItem
                            onClick={() =>
                              handleMenuItemClick("/dashboard/my-leave")
                            }
                            className={`submenu-item ${
                              location.pathname === "/dashboard/my-leave"
                                ? "active-menu"
                                : ""
                            }`}
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            My Leaves
                          </MenuItem>
                        )}
                    </>
                    {userPermissions?.includes(
                      "attendance_view_all_attendance",
                    ) && (
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick("/dashboard/attendance")
                        }
                        className={`submenu-item ${
                          location.pathname === "/dashboard/attendance"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        Attendance
                      </MenuItem>
                    )}
                    {userPermissions?.includes(
                      "leavereport_view_all_leaves",
                    ) && (
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick("/dashboard/leaves-report")
                        }
                        className={`submenu-item ${
                          location.pathname === "/dashboard/leaves-report"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        Leaves
                      </MenuItem>
                    )}
                    {userPermissions?.includes(
                      "holidayscalender_view_holidayscalender",
                    ) && (
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick("/dashboard/holidays-calendar")
                        }
                        className={`submenu-item ${
                          location.pathname === "/dashboard/holidays-calendar"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        Calendar
                      </MenuItem>
                    )}
                  </SubMenu>
                )}

                {!isCustomer && !isTechnician && !isSubCustomer && !isSales && (
                  <SubMenu
                    className={`mb-1 submenu`}
                    open={fieldWorkerSubMenuOpen}
                    label={
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        <FaUserFriends className="me-2" /> Users
                      </span>
                    }
                    onOpenChange={() =>
                      setFieldWorkerSubMenuOpen(!fieldWorkerSubMenuOpen)
                    }
                  >
                    <MenuItem
                      onClick={() =>
                        handleMenuItemClick("/dashboard/technician")
                      }
                      className={`submenu-item ${
                        location.pathname === "/dashboard/technician"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      Technician
                    </MenuItem>

                    <MenuItem
                      onClick={() => handleMenuItemClick("/dashboard/sales")}
                      className={`submenu-item ${
                        location.pathname === "/dashboard/sales"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      Sales
                    </MenuItem>

                    {(isAdmin || isAgent || isSuperuser) && (
                      <>
                        {!isAdmin && !isAgent && !isSuperuser && (
                          <MenuItem
                            onClick={() =>
                              handleMenuItemClick("/dashboard/admin")
                            }
                            className={`mb-1 ${
                              location.pathname === "/dashboard/admin"
                                ? "active-menu"
                                : ""
                            }`}
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            Admin
                          </MenuItem>
                        )}
                        {!isAgent && (
                          <MenuItem
                            onClick={() =>
                              handleMenuItemClick("/dashboard/agent")
                            }
                            className={`mb-1 ${
                              location.pathname === "/dashboard/agent"
                                ? "active-menu"
                                : ""
                            }`}
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            Executive
                          </MenuItem>
                        )}
                        {!isSuperuser && !isAgent && (
                          <MenuItem
                            onClick={() =>
                              handleMenuItemClick("/dashboard/superuser")
                            }
                            className={`mb-1 ${
                              location.pathname === "/dashboard/superuser"
                                ? "active-menu"
                                : ""
                            }`}
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            Manager
                          </MenuItem>
                        )}
                      </>
                    )}

                    <MenuItem
                      onClick={() =>
                        handleMenuItemClick("/dashboard/track-all")
                      }
                      className={`submenu-item ${
                        location.pathname === "/dashboard/track-all"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      Track All
                    </MenuItem>
                  </SubMenu>
                )}

                {userPermissions?.includes("expenses_view_all_expenditure") && (
                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("/dashboard/expenditure")
                    }
                    className={`submenu-item ${
                      location.pathname === "/dashboard/expenditure"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaWallet className="me-2" />
                    Expenditure
                  </MenuItem>
                )}

                {userPermissions?.includes("expenses_view_expenses") &&
                  !isAdmin && (
                    <MenuItem
                      onClick={() => handleMenuItemClick("/dashboard/Expense")}
                      className={`submenu-item ${
                        location.pathname === "/dashboard/Expense"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      <FaRegMoneyBillAlt className="me-2" />
                      My Expense
                    </MenuItem>
                  )}

                {userPermissions?.includes(
                  "servicerequest_view_servicerequest",
                ) && (
                  <SubMenu
                    className="mb-1 submenu"
                    open={stockSubMenuOpen}
                    label={
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        <FaBoxes className="me-2" /> Stock
                      </span>
                    }
                    onOpenChange={() => setStockSubMenuOpen(!stockSubMenuOpen)}
                  >
                    <MenuItem
                      onClick={() =>
                        handleMenuItemClick("/dashboard/servicerequests")
                      }
                      className={`submenu-item ${
                        location.pathname === "/dashboard/servicerequests"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      <FaTools className="me-2" />
                      Material Request
                    </MenuItem>

                    <MenuItem
                      onClick={() =>
                        handleMenuItemClick("/dashboard/inventory")
                      }
                      className={`submenu-item ${
                        location.pathname === "/dashboard/inventory"
                          ? "active-menu"
                          : ""
                      }`}
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      <FaBoxes className="me-2" />
                      Inventory
                    </MenuItem>
                  </SubMenu>
                )}

                {(isAdmin || isAgent || isSuperuser || isSales) &&
                  !isCustomer &&
                  !isTechnician && (
                    <SubMenu
                      className={`mb-1 submenu`}
                      open={crmSubMenuOpen}
                      label={
                        <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                          <FaUsers className="me-2" /> CRM
                        </span>
                      }
                      onOpenChange={() => setCrmSubMenuOpen(!crmSubMenuOpen)}
                    >
                      <MenuItem
                        onClick={() =>
                          handleMenuItemClick("/dashboard/customer-list")
                        }
                        className={`submenu-item ${
                          location.pathname === "/dashboard/customer-list"
                            ? "active-menu"
                            : ""
                        }`}
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        {labels.customer}
                      </MenuItem>
                      {userPermissions?.includes("lead_view_lead") && (
                        <MenuItem
                          onClick={() =>
                            handleMenuItemClick("/dashboard/lead-list")
                          }
                          className={`submenu-item${
                            location.pathname === "/dashboard/lead-list"
                              ? "active-menu"
                              : ""
                          }`}
                          style={{ fontWeight: "bold", fontSize: "16px" }}
                        >
                          Lead
                        </MenuItem>
                      )}
                    </SubMenu>
                  )}

                {userPermissions?.includes("amc_view_amc") && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("/dashboard/amc")}
                    className={`mb-1 ${
                      location.pathname === "/dashboard/amc"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaClipboardCheck className="me-2" />
                    AMC
                  </MenuItem>
                )}

                {userPermissions?.includes(
                  "servicecategory_view_servicecategory",
                ) && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("/dashboard/services")}
                    className={`mb-1 ${
                      location.pathname === "/dashboard/services"
                        ? "active-menu"
                        : ""
                    } headmenu`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaWrench className="me-2" />
                    Service
                  </MenuItem>
                )}

                {isAdmin && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("/dashboard/logs")}
                    className={`mb-1 ${
                      location.pathname === "/dashboard/logs"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaClipboardList className="me-2" />
                    Logs
                  </MenuItem>
                )}

                {isAdmin && (
                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("/dashboard/subscription")
                    }
                    className={`mb-1 ${
                      location.pathname === "/dashboard/subscription"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaCreditCard className="me-2" />
                    Subscription & Payments
                  </MenuItem>
                )}

                {(isAdmin || isSuperAdmin) && (
                  <MenuItem
                    onClick={() => handleMenuItemClick("/dashboard/support")}
                    className={`mb-1 ${
                      location.pathname === "/dashboard/support"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    <FaRegLifeRing className="me-2" /> Help & Support
                  </MenuItem>
                )}
              </div>
            </>
          ) : (
            <>
              {!isSuperAdmin && (
                <SubMenu
                  className={`mb-1 submenu`}
                  open={attendanceSubMenuOpen}
                  label={
                    <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                      <FaCalendarAlt className="me-2" /> Attendance
                    </span>
                  }
                  onOpenChange={() =>
                    setAttendanceSubMenuOpen(!attendanceSubMenuOpen)
                  }
                >
                  <MenuItem
                    onClick={() => handleMenuItemClick("/dashboard/my-leave")}
                    className={`submenu-item ${
                      location.pathname === "/dashboard/my-leave"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    My Leaves
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick("/dashboard/holidays-calendar")
                    }
                    className={`submenu-item ${
                      location.pathname === "/dashboard/holidays-calendar"
                        ? "active-menu"
                        : ""
                    }`}
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    Calendar
                  </MenuItem>
                </SubMenu>
              )}
            </>
          )}
        </Menu>
      </div>
    </Sidebar>
  );
}
export default SidebarComponent;
